// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_logoutButton__4DZbj {
  background-color: #fff;
  cursor: pointer;
  color: #18316e;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #18316e;
  gap: 5px;
  font-family: "Inter";
  font-size: 1rem;
  transition: transform 0.3s ease-in-out;
  border-radius: 8px;
  padding: 0.7rem 0.7rem;
  min-width: 8rem;
}

.styles_logoutButton__4DZbj:hover {
  transform: scale(1.1);
}

.styles_logoutButton__4DZbj:active {
  background-color: #1976d2;
}

@media (max-width: 770px) {
  .styles_logoutButton__4DZbj {
    width: 85%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhiteButton/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".logoutButton {\n  background-color: #fff;\n  cursor: pointer;\n  color: #18316e;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #18316e;\n  gap: 5px;\n  font-family: \"Inter\";\n  font-size: 1rem;\n  transition: transform 0.3s ease-in-out;\n  border-radius: 8px;\n  padding: 0.7rem 0.7rem;\n  min-width: 8rem;\n}\n\n.logoutButton:hover {\n  transform: scale(1.1);\n}\n\n.logoutButton:active {\n  background-color: #1976d2;\n}\n\n@media (max-width: 770px) {\n  .logoutButton {\n    width: 85%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoutButton": `styles_logoutButton__4DZbj`
};
export default ___CSS_LOADER_EXPORT___;
